/** Load Horizon enhancements only where their elements are rendered.
 * Observe added elements too: predictive search, quick-add and the Section
 * Rendering API can introduce components after the initial page has loaded.
 * Existing cart/configurator entry points and native forms stay untouched.
 */
export function startComponentLoader(entries, {
  root = document.documentElement,
  Observer = MutationObserver,
  loadModule = (url) => import(url),
  reportError = (error) => console.error('[Feeedback component loader]', error),
} = {}) {
  const pending = new Map(entries.map(({ selector, url }) => [url, selector]));
  const loads = new Map();

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    for (const [url, selector] of pending) {
      if (!node.matches(selector) && !node.querySelector(selector)) continue;
      // Reserve before importing: repeated mutations never start duplicate loads.
      pending.delete(url);
      loads.set(url, Promise.resolve().then(() => loadModule(url)).catch(reportError));
    }
  }

  const observer = new Observer((records) => {
    if (!pending.size) { observer.disconnect(); return; }
    for (const record of records) for (const node of record.addedNodes) scan(node);
  });
  observer.observe(root, { childList: true, subtree: true });
  scan(root);
  return { loads, disconnect: () => observer.disconnect() };
}

if (typeof document !== 'undefined') {
  const config = document.getElementById('fb-component-modules');
  if (config) startComponentLoader(JSON.parse(config.textContent));
}
